import React from 'react';
import PropTypes from 'prop-types';
import Dropdown from "../../../../Common/Dropdown/Dropdown";
import {refBlur, refFocus} from "../../../../../tools/tools";
import {withTranslation} from "react-i18next";
import {connect} from "react-redux";
import {setRoundTrip} from "../../../../../services/flightCourse/actions";
import styles from '../../../SearchWidget.module.scss';

const RoundTripSelector = ({options, containerRef, prevRef, nextRef, setRoundTrip, roundTrip, imagineMode, disableMultiCity, t, ...props}) => {

    const optionsMock = [
        {label: t('One-way'), value: 'ONEWAY'},
        {label: t('Round trip'), value: 'RETURN'},
    ];

    if (!disableMultiCity) {
        optionsMock.push({label: t('Multicity'), value: 'MULTI'});
    }

    const onChangeHandler = (option) => {
        setRoundTrip(option.value);
        refBlur(containerRef);
        if (roundTrip !== 'MULTI' && option.value !== 'MULTI') {
            refFocus(nextRef);
        }
    };

    const getOptionByValue = (value) => {
        for (const opt of optionsMock) {
            if (opt.value === value) {
                return opt;
            }
        }

        return null;
    };

    const currentValue = getOptionByValue(roundTrip);

    return (
        <div className={[styles.roundTripContainer, 'sw-hidden-on-shrink'].join(' ')}>
            <Dropdown
                options={imagineMode ? optionsMock.map(o => o.value === 'MULTI' ? {...o, disabled: true} : o) : optionsMock}
                optionsIdentifier={'value'}
                placeholder={t('Round trip')}
                onChange={onChangeHandler}
                setKeyboardAnchorOnCurrentValueAlways
                value={currentValue}
                containerRef={containerRef}
                animated
                prevRef={prevRef}
                nextRef={nextRef}/>
        </div>
    );
};

RoundTripSelector.propTypes = {
    ...Dropdown.propTypes,
    setRoundTrip: PropTypes.func,
    disableMultiCity: PropTypes.bool,
    roundTrip: PropTypes.any,
    imagineMode: PropTypes.bool,
    prevRef: PropTypes.any,
    nextRef: PropTypes.any,
    t: PropTypes.func,
};

RoundTripSelector.defaultProps = {
    ...Dropdown.defaultProps,
    setRoundTrip: () => null,
    disableMultiCity: false,
    roundTrip: null,
    imagineMode: false,
    prevRef: null,
    nextRef: null,
    t: str => str,
};

export default withTranslation()(connect(state => ({
    roundTrip: state.flightCourse.roundTrip,
    imagineMode: state.flightCourse.imagineMode}), {setRoundTrip})(RoundTripSelector));
